(ns web3.screens.pro.flow
  (:require [web3.view :as v]
            [web3.i18n :as i]
            [web3.screens.service-provider :as service-provider]
            [web3.queries.profile :as q-profile]
            [web3.queries.root :as q-root]
            [web3.routing.core :as routing]
            [web3.components.widgets :as widgets]
            [reagent.core :as r]
            [web3.constants :as constants]
            [web3.forms.fields :as fields]
            [web3.modals.forms :as forms]
            [web3.utils :as utils]
            [web3.screens.pro.utils :as pro-utils]
            [web3.components.text :as text]
            [web3.persistence.schema :as schema]
            [web3.forms.validation :as validation]
            [web3.persistence.graphql :as g]
            [clojure.string :as str]
            [web3.components.widgets :as w]
            [web3.log :as log]
            [web3.screens.sponsor :as sponsor]
            [re-frame.core :as rf]
            [web3.env :as env]
            [web3.persistence.current-property :as current-property]
            [web3.screens.pro.utils :as pro]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup]))

(def form-subheading :div.text-uppercase.text-dark-gray.text-size-13.line-h-17.weight-medium.margin-top-3.margin-bottom-2)

(defn divider-line [& [props]]
  [:div.bg-light-gray.margin-v-3
   (v/merge-props props
                  {:style {:height 1}})])

(v/defview detail
  {:header {:title (i/get :i/professional-profile)}}
  []
  ;; TODO
  ;; form to edit the pro profile of current user.
  ;; ideally, we could re-use service-provider endpoints,
  ;; perhaps by specifying the current user ID as the service provider ID.
  [service-provider/detail {:service-provider-id (-> (q-root/me)
                                                     (:me)
                                                     (:id))}])

(def pro-sequence [:pro/start
                   :pro/contact
                   :pro/address
                   :pro/pictures
                   :pro/share-link
                   :pro/review
                   :pro/premium-offer
                   :pro/business-profile
                   #_:pro/premium-appearance
                   #_:pro/premium-confirm])

(defn next-in-sequence [this]
  (let [handler (-> this :props :handler)]
    (->> pro-sequence
         (drop-while #(not= % handler))
         (rest)
         (first))))

(defn get-index [handler]
  (->> pro-sequence
       (take-while #(not= % handler))
       (count)))

(def profile-keys [:email
                   :firstName
                   :lastName
                   :professionName
                   :companyName
                   :website
                   :mobilePhone
                   :officePhone
                   :address
                   :companyImage
                   :personImage
                   :proReferralLinkPath])


(defn get-profile []
  (-> (q-root/me)
      :me
      (select-keys profile-keys)))

(defn pro-form-submit
  ([e parent-component fields]
   (pro-form-submit e parent-component fields true))
  ([e parent-component fields should-next?]
   (pro-form-submit e parent-component fields should-next? {}))
  ([e parent-component fields should-next? opts]
   (let [{db-address :address :as db-data} (get-profile)
         {:keys [or-but-required]} opts
         data (-> (forms/form-data)
                  (->> (utils/map-keys pro-utils/simplify-path)
                       (merge db-data))
                  (update :address (fn [address]
                                     (merge db-address
                                            (utils/map-keys pro-utils/simplify-path address)))))
         invalid-required-or-fields (every? nil?
                                            (map #((utils/simplify-keyword %) data) or-but-required))
         validations (schema/validate-paths fields data)]
     (log/sym invalid-required-or-fields)
     (.preventDefault e)
     (swap! (:state parent-component) assoc :dirty? true)
     (when invalid-required-or-fields
       (swap! (:state parent-component) assoc :invalid-required-or-fields invalid-required-or-fields))
     (when-not (and (validation/invalid? validations)
                    invalid-required-or-fields)
       (q-profile/profile-update! data {:component parent-component
                                        :on-complete #(do
                                                        (when should-next?
                                                          (routing/nav!
                                                            (routing/path-for
                                                              [(next-in-sequence parent-component)])))
                                                        (forms/clear-state!))
                                        :refetch [q-root/me]})))))

(defn circle-crumbs [this fields]
  (let [current-handler (get-in this [:props :handler])]
    (into [:div.flex.justify-center.pad-all-2.absolute.bottom-0.left-0.right-0]
          (for [handler pro-sequence
                :let [current? (= current-handler handler)]]
            [:a.margin-h-1.round-100p
             {:on-click #(pro-form-submit % this fields false)
              :href (routing/path-for [handler])
              :class (if current? "bg-dark-gray"
                                  "border-gray bg-off-white")
              :style {:width 12
                      :height 12}}]))))

(v/defview offer
  {:index (get-index :pro/offer)
   :header {:title (i/get :i/centriq-pro)}}
  []
  (let [take-action [widgets/black-button {:href (routing/path-for [:pro/start])
                                           :class "block margin-all-3"}
                     (i/get :pro/get-account)]
        heading :div.weight-semi-bold.text-size-20.line-h-24.pad-h-3.margin-bottom-2.margin-top-4
        p :div.weight-light.text-size-14.line-h-18.pad-h-3.margin-v-2]
    [:div.bg-white.pre-wrap.pad-bottom-4
     [:img.width-100p {:src "/images/pro-1.jpg"}]
     [:div.weight-semi-bold.flex.items-center.pad-h-3
      {:style {:color (:centriq constants/colors)
               :font-size "48px"}}
      (:partner/name env/config)
      (-> pro/icon-flag
          (hiccup/size 100)
          (hiccup/class "margin-left-3"))]
     [:div.text-size-32.weight-light.pad-h-3.line-h-40
      (i/to-do "Grow your business with " (:partner/name env/config) " Pro.")]
     [:div.pad-h-3.pad-v-3.text-size-20.line-h-24.weight-light
      (i/to-do (str (:partner/name env/config) " Pro offers valuable tools and capabilities to grow your business and be remembered by your clients, from closing gifts that keep on giving to marketing opportunities that drive relevance and revenue.\n\n" (:partner/name env/config) " Pro has features that benefit every profession related to the home."))]
     take-action
     [heading (i/to-do "Be at the top of your client’s contacts")]
     [p (i/to-do (str "Every client you introduce to " (:partner/name env/config) " will have your contact card at the top of their Service Providers tab."))]
     [p (i/to-do (str "How awesome would it be if you serviced an appliance and handed them all the manuals and how-to videos in an app? Now you can with " (:partner/name env/config) "."))]
     [:img.width-100p {:src "/images/pro-2.jpg"}]
     [heading (i/to-do "Have your brand front and center")]
     [p (i/to-do (str "Personalize your client’s " (:partner/name env/config) " by adding your branding right on the home screen and throughout the app."))]
     [p (i/to-do "Important notices, such as product recall emails, will show your branding as well.")]
     [:img.width-100p {:src "/images/pro-3.jpg"}]
     [heading (i/to-do "One link, many new clients")]
     [p (i/to-do (str "Share the link to your personal " (:partner/name env/config) " Pro page in emails, banners and social media, on your business card and on the side of your truck. Anyone signing up with that link will automatically be your lead, see your branding, and have your profile at the top of their service providers tab."))]
     [:img.width-100p {:src "/images/pro-4.jpg"}]
     [heading (i/to-do (str "Don’t just hand your clients a business card. Give them " (:partner/name env/config) ", it’s free.*"))]
     [p (i/to-do (str "Get your " (:partner/name env/config) " Pro profile and bring your customers to " (:partner/name env/config) ". They’ll be thanking you for it."))]
     take-action
     [p (i/to-do (str "* Most of " (:partner/name env/config) " Pro is free. Some marketing options are a paid upgrade. The app will always be free."))]]))

(def heading :div.text-size-20.weight-medium.line-h-24)
(def p :div.weight-light.text-size-14.line-h-18.margin-v-1)

(defn pro-header []
  [:div
   [heading
    (i/to-do "Create your Professional Profile")]
   [p
    (i/to-do (str "This is the information your clients will see when they view your business card inside "
                  (:partner/name env/config)
                  "."))]])

(defn next-link
  ([this] (next-link this false))
  ([this loading?]
   (list [:div.flex-auto {:key "spacer"}]
         [widgets/graphql-submit-button {:key "submit-btn"
                                         :label (i/get :i/next)
                                         :form-loading? loading?
                                         :state (g/mutation-state this)}])))

(defn pro-form [{:keys [parent-component fields opts]} & items]
  (into [:form.pad-all-3.flex.flex-column.min-height-100p.pad-bottom-4
         ;; TODO
         ;; save each screen before advancing to the next,
         ;; showing feedback if there are errors.
         {:on-submit #(pro-form-submit % parent-component fields true opts)}]
        items))

(v/defview start
  {:index (get-index :pro/start)
   :component-did-mount #(do (utils/focus-first-input! %)
                             (rf/dispatch [:tracking/referred])
                             (forms/assoc-field! :User/proPlan 'unlimited_free))
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [this (r/current-component)
        {:keys [invalid-required-or-fields] :as state} (:state this)
        fields [:User/firstName
                :User/lastName
                :ServiceProvider/companyName]]

    [pro-form {:parent-component this
               :fields fields
               :opts {:or-but-required [:User/firstName :User/lastName :ServiceProvider/companyName]}}
     (log/info @state)
     [pro-header]
     [form-subheading (i/to-do "Name & Business")]
     (doall (map (partial pro-utils/render-field this) fields))
     (when invalid-required-or-fields
       [:div {:style {:color (:red constants/colors)}}
        (i/to-do "First Name, Last Name or Company name are required")])
     (pro-utils/render-field this :ServiceProvider/professionName)
     (next-link this)
     (circle-crumbs this fields)]))

(v/defview contact
  {:index (get-index :pro/contact)
   :component-did-mount utils/focus-first-input!
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [this (r/current-component)
        fields [:ServiceProvider/website
                :ServiceProvider/officePhone
                :ServiceProvider/mobilePhone]
        me (q-root/me)]
    [pro-form {:parent-component this
               :fields fields}
     [pro-header]
     [form-subheading (i/to-do "Contact Information")]
     [text/input {:label (i/get :User/email)
                  :read-only? true
                  :value (-> me :me :email)}]
     (doall (map (partial pro-utils/render-field this) fields))
     (next-link this)
     (circle-crumbs this fields)]))

(v/defview address
  {:index (get-index :pro/address)
   :component-did-mount (fn [this]
                          (utils/focus-first-input! this)
                          (when-let [address (->> (current-property/get-property)
                                                  :address
                                                  (utils/map-keys #(keyword "StreetAddress" %)))]
                            (mapv (fn [[k v]] (forms/assoc-field! [:address k] v)) address)))
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [this (r/current-component)
        fields {:StreetAddress/street1 [:address :StreetAddress/street1]
                :StreetAddress/street2 [:address :StreetAddress/street2]
                :StreetAddress/locality [:address :StreetAddress/locality]
                :StreetAddress/region [:address :StreetAddress/region]
                :StreetAddress/postalCode [:address :StreetAddress/postalCode]}]
    [pro-form {:parent-component this
               :fields fields}
     [pro-header]
     [form-subheading (i/to-do "Contact Information")]
     [:div
      (pro-utils/render-field this [:address :StreetAddress/street1])
      (pro-utils/render-field this [:address :StreetAddress/street2])
      [:div.flex
       (pro-utils/render-field this [:address :StreetAddress/locality])
       [:div.margin-right-3]
       [:div.flex-auto
        (pro-utils/render-field this [:address :StreetAddress/region])]]
      (pro-utils/render-field this [:address :StreetAddress/postalCode])]
     (next-link this)
     (circle-crumbs this fields)]))

(v/defview pictures
  {:index (get-index :pro/pictures)
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [this (r/current-component)
        me (:me (q-root/me))
        fields [:User/profileImage
                :User/logoImage]
        form-loading? (forms/loading?)]
    [pro-form {:parent-component this
               :fields fields}
     [heading (i/to-do "Add a Profile Picture")]
     [p (i/to-do "Be recognized instantly with a profile picture and business logo (optional).")]
     [:div.flex.items-center
      [:div.width-50p
       (pro-utils/render-field this :User/personImageLink)]
      [:img.margin-left-2.flex-none.round-100p {:src (-> me
                                                         :personImage
                                                         :link)
                                                :style {:width 150
                                                        :height 150}}]]
     [:div.flex.items-center
      [:div.width-50p
       (pro-utils/render-field this :User/companyImageLink)]
      [:img.margin-left-2.flex-none.round-100p {:src (-> me
                                                         :companyImage
                                                         :link)
                                                :style {:width 150
                                                        :height 150}}]]
     (next-link this form-loading?)
     (circle-crumbs this fields)]))

(v/defview share-link
  {:index (get-index :pro/share-link)
   :component-did-mount (fn [this]

                          (utils/focus-first-input! this)


                          ;; pre-populate link with phone number, if it has not already been set
                          (when-not (forms/get-field :User/proReferralLinkPath)
                            (when-let [default-link (let [{:keys [proReferralLinkPath
                                                                  officePhone
                                                                  mobilePhone]} (:me (q-root/me))]
                                                      (or proReferralLinkPath
                                                          (some-> (or officePhone
                                                                      mobilePhone)
                                                                  (utils/some-str)
                                                                  (pro-utils/encode-referral-link))))]
                              (forms/assoc-field! :User/proReferralLinkPath default-link))))
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [this (r/current-component)
        fields [:User/proReferralLinkPath]]
    [pro-form {:parent-component this
               :fields fields}
     [heading (i/to-do (str "Set your unique " (:partner/name env/config) " Pro link"))]
     [p (str "Anyone who joins " (:partner/name env/config) " using your " (:partner/name env/config)
             " Pro link  will be linked to you and automatically have your"
             " contact card in their Service Providers tab.\n")]
     [p "You can use the link in social media, emails, banners, on your business card and wherever else you’d like.\n"]
     [p "Your Pro link can be any 10 numbers, such as your phone number."]

     [:div.flex.items-center
      [:div.weight-bold {:style {:margin-top -3
                                 :margin-right 2}}
       "homeserve.app.link/"]
      (pro-utils/render-field this :User/proReferralLinkPath
                              {:encoding {:encode pro-utils/encode-referral-link
                                          :decode pro-utils/decode-referral-link}
                               :container {:class "flex-auto"}})]

     (next-link this)
     (circle-crumbs this fields)]))

(v/defview review
  {:index (get-index :pro/review)
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [this (r/current-component)
        me (:me (q-root/me))
        sponsor-preview {:personName (str (:firstName me) " " (:lastName me))}]
    [pro-form {:parent-component this}
     [heading (i/to-do "Congrats! Your profile is complete.")]
     [p (i/to-do (str "Here is what your clients will see when they view your business card inside " (:partner/name env/config) ":"))]
     [:div.margin-bottom-3]
     [w/form-card
      [:div
       [:div.text-size-20.weight-medium.line-h-24
        (->> [(:firstName me) (:lastName me)]
             (str/join " "))]
       [:div.text-size-13.weight-medium.line-h-18
        (->> [(:professionName me)
              (:companyName me)]
             (keep utils/some-str)
             (interpose [:br]))]
       [divider-line]]
      [:div.margin-v-3
       (->> (for [field [:ServiceProvider/officePhone
                         :ServiceProvider/mobilePhone
                         :ServiceProvider/website
                         :User/email]
                  :let [value (get me (utils/simplify-keyword field))]
                  :when value]
              (fields/from-schema field
                                  {:value value
                                   :read-only? true}))
            (doall))
       [text/input {:key :address
                    :label (i/get :i/address)
                    :multi-line? true
                    :read-only? true
                    :value (schema/address->text (get me :address))}]]]
     [:div.flex-auto.margin-bottom-3.field-border-bottom]
     (next-link this)
     (circle-crumbs this nil)]))

(v/defview premium-offer
  {:index (get-index :pro/review)
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [this (r/current-component)
        spacer :div.margin-bottom-3
        me (:me (q-root/me))
        sponsor-preview {:personName (str (:firstName me) " " (:lastName me))
                         :companyName (:companyName me)
                         :personImage (:personImage me)
                         :companyImage (:companyImage me)}]
    [pro-form {:parent-component this}
     [heading (i/to-do "Your account has been upgraded for free!")]
     [p (i/to-do (str "You'll get 12 months of Premium marketing inside "
                      (:partner/name env/config) ". "
                      "Your profile will look like this and show up on the home "
                      "screen of every one of your " (:partner/name env/config) " contacts:"))]
     [spacer]
     [:div.round-3.pad-h-3.pad-v-3.shadow-card
      {:class "text-black bg-white"}
      [sponsor/with-address sponsor-preview]]
     [spacer]
     [heading (i/to-do "You now have the best marketing!")]
     [p (i/to-do (str "With the free " (:partner/name env/config) " Pro account, your contact card is "
                      "always at the top of your client's Service Providers tab. "
                      "With your upgrade to the Premium " (:partner/name env/config) " Pro account, "
                      "your brand will be front and center every time your clients "
                      "use the app or get a notification. Your brand will show on "
                      "the home screen and at the top of the menu, and all " (:partner/name env/config) " "
                      "notifications, such as our safety Safety Recall warnings will "
                      "carry your brand as well."))]
     [spacer]
     [heading "Yours free for 12 months"]
     [spacer]
     [:div.round-3.pad-h-3.pad-v-3.flex-center.text-size-34
      {:style {:background-color "#FFFFFF"}}
      [:table.width-100p.text-center.weight-extra-light
       [:tr
        [:td.width-50p [:s.width-50p {:style {:font-size "150%"}} "$395"]]
        [:td.width-50p {:style {:font-size "150%"}} "FREE"]]]
      [:div.flex-center.text-center.text-dark-gray
       [p (str "PREMIUM " (:partner/name env/config) " PRO")
        [:br]
        "FREE FOR THE FIRST 12 MONTHS"]]]
     [spacer]


     [:table.width-100p.weight-light.text-size-14.line-h-18
      [:tbody
       [:tr.bg-white
        [:td.pad-all-2.weight "Charged Today"]
        [:td.text-right.pad-all-2 [:s.pad-right-2 "$ 395.00"] "$0.00"]]
       [:tr
        [:td.pad-all-2 "Charged Annually thereafter"
         [:br]
         "(if you choose to renew it)"]
        [:td.text-right.pad-all-2 "$ 395.00"]]
       [:tr.bg-white
        [:td.pad-all-2 "Users"]
        [:td.text-right.pad-all-2 "Unlimited"]]
       [:tr
        [:td.pad-all-2 "Properties"]
        [:td.text-right.pad-all-2 "Unlimited"]]
       [:tr.bg-white
        [:td.pad-all-2 "App Branding"]
        [:td.text-right.pad-all-2 shapes/checkmark-thin]]
       [:tr
        [:td.pad-all-2 (str (:partner/name env/config) " vanity link")]
        [:td.text-right.pad-all-2 shapes/checkmark-thin]]
       [:tr.bg-white
        [:td.pad-all-2 "Cancel any time"]
        [:td.text-right.pad-all-2 shapes/checkmark-thin]]]]
     [spacer]
     [text/input {:label (i/to-do "Promo Code")
                  :read-only? true
                  :helptext "Promo code applied successfully"
                  :helptext-persistent? true
                  :value "PREMIUMFREE12"}]


     [spacer]
     (next-link this)
     (circle-crumbs this nil)]))

(v/defview business-profile
  {:index (get-index :pro/business-profile)
   :header {:modal-sequence pro-sequence
            :title (i/get :i/professional-profile)}}
  []
  (let [{:keys [state] :as this} (r/current-component)
        me (:me (q-root/me))
        fields [:User/proReferralLinkPath]
        partner-domain "homeserve.app.link/"
        referral-link (-> (str "https://" partner-domain (:proReferralLinkPath me))
                          fields/decode-referral-link)

        spacer :div.margin-bottom-3

        select! #(let [^js el (:input @state)
                       content-length (some-> referral-link (count))]
                   (doto el
                     (.focus)
                     (aset "selectionStart" 0)
                     (aset "selectionEnd" content-length)))
        copy! (fn []
                (select!)
                (let [copied? (js/document.execCommand "copy")]
                  (when copied?
                    (swap! state assoc :ephemeral-helptext "Copied")
                    (js/setTimeout #(do (swap! state dissoc :ephemeral-helptext))
                                   3000))))]

    [pro-form {:parent-component this
               :fields fields}
     [spacer]
     [spacer]
     [:div.text-center
      [heading (i/to-do (str "Welcome, " (:firstName me) "."))]
      [heading (i/to-do (str "You are now a " (:partner/name env/config) " Pro!"))]]
     [spacer]
     [spacer]
     [spacer]
     [p (str "Use this link to share " (:partner/name env/config)
             " with all your contacts, in email, social media, banners or on your business card:")]
     [spacer]
     [text/render-helptext {:persistent? true
                            :ephemeral-helptext (:ephemeral-helptext @state)}]
     [:div.flex.items-center
      [:div.weight-bold.width-100p
       [:input.width-100p
        {:ref #(swap! state assoc :input %)
         :style {:border :none
                 :font :inherit
                 :background :inherit}
         :read-only true
         :default-value referral-link}]]]
     [spacer]
     [widgets/primary-button {:class "border-gray"
                              :on-click copy!}
      (i/get :i/copy-link)]
     [spacer]
     [widgets/black-button {:href (routing/path-for :router/form-modal nil
                                                    :router/drawer [:account/menu])}
      (i/get :i/done)]
     [spacer]
     (circle-crumbs this fields)]))
